import {
    PROTOCOL_TYPE_GET_REQUEST, PROTOCOL_TYPE_GET_SUCCESS, PROTOCOL_TYPE_GET_ERROR,
    PROTOCOL_TYPE_GET_BY_KEY_REQUEST, PROTOCOL_TYPE_GET_BY_KEY_SUCCESS, PROTOCOL_TYPE_GET_BY_KEY_ERROR,
    PROTOCOL_TYPE_ADD_REQUEST, PROTOCOL_TYPE_ADD_SUCCESS, PROTOCOL_TYPE_ADD_ERROR,
    PROTOCOL_TYPE_EDIT_REQUEST, PROTOCOL_TYPE_EDIT_SUCCESS, PROTOCOL_TYPE_EDIT_ERROR,
    PROTOCOL_TYPE_DELETE_REQUEST, PROTOCOL_TYPE_DELETE_SUCCESS, PROTOCOL_TYPE_DELETE_ERROR
} from "../constants/protocolTypeConstants";

const initialState = {
    protocolTypes: [],
    protocolType: {},
    loading: false,
    success: null,
    error: null,
    protocolTypeRequestedCount: 0,
};

export const protocolTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROTOCOL_TYPE_GET_REQUEST:
            return {
                ...state,
                protocolTypeRequestedCount: ++state.protocolTypeRequestedCount,
                loading: true,
            };
        case PROTOCOL_TYPE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                protocolTypes: action.payload,
                success: true,
            };
        case PROTOCOL_TYPE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROTOCOL_TYPE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROTOCOL_TYPE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                protocolType: action.payload,
                success: true,
            };
        case PROTOCOL_TYPE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROTOCOL_TYPE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROTOCOL_TYPE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROTOCOL_TYPE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROTOCOL_TYPE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROTOCOL_TYPE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROTOCOL_TYPE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROTOCOL_TYPE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROTOCOL_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROTOCOL_TYPE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
